<template>
  <b-container fluid class="presentation">
    <b-row>
      <b-col md="4" sm="12">
        <Navbar class="d-none d-md-flex presentation-menu"></Navbar>
      </b-col>
      <b-col md="8" sm="12">
        <div class="block">
        <p>
        Cartographe indépendant depuis 2020.
        </p>
          <p>
            Féru de géographie et de géopolitique, mes diverses expériences en collectivités
            publiques, en agence d’urbanisme et dans l’économie sociale et solidaire se sont
            révélées enrichissantes mais trop éloignées de ma profonde envie. J’ai alors décidé
            de revenir à la passion qui m’anime le plus : la cartographie.
          </p>
          <p>
            Offrir une interprétation graphique à haute teneur artistique, de phénomènes
            spatialisés en respectant une rigueur scientifique… quel plus beau programme ?
          </p>
        </div>
          <div class="block">
            <p class="title">
              Ma formation en quatre lignes :
            </p>
            <p>
              <span>2016</span> Master 2 de Géopolitique à l'Institut Français de Géopolitique de
              Paris 8<br>
              <span>2015</span> Master 2 d'Urbanisme et aménagement des territoires à l'IAUL de
              Lille<br>
              <span>2010-2012</span> Hypokhâgne et Khâgne LSH<br>
              <span>2010</span> Baccalauréat scientifique<br>
            </p>
            <p>
              Mes mémoires universitaires : <a href="http://independent.academia.edu/ArthurBeauboisJude">ici</a>
            </p>
          </div>
          <div class="block">
            <p class="title">
              Mes principaux outils de travail :
            </p>
            <p>
              <span>QGIS :</span> pour la rigueur scientifique<br>
              <span>Illustrator / Photoshop :</span> pour une représentation originale et
              soignée<br>
              <span>Blender :</span> pour le réalisme<br>
              <span>Aftereffect :</span> pour l'animation<br>
              <span>Un peu de code :</span> pour l’interactivité<br>
            </p>
            <p class="last">
              Et une multitude d'autres petits logiciels, au service d'une imagination à
              satisfaire.
            </p>
          </div>
        <div class="block">
          <p class="title">
            Publications qui présentent mon travail :
          </p>
          <p>
            <b><i>Atlas of Design Vol. 6</i></b>
            (North American Cartographic Information Society, 2022)<br>
            <b><i>The Quarantine Atlas</i></b>, Mapping Global Life Under COVID-19
            (Laura Bliss, Bloomberg CityLab Project, Black Dog & Leventhal 2022)<br>
            <b><i>Journal Le Monde</i></b> : Extension du
            domaine de la carte (Pascale Krémer, mai 2021)<br>
            <b><i>The Cartographic Journal Vol. 57:3</i></b>,
             Mapping and Counter-Mapping COVID-19: From Crisis
            to Cartocracy (Alexander J. Kent, British Cartographic Society, 2020)<br>
          </p>
        </div>
        <img class="arthur-image" src="../assets/images/arthur.png"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
};
</script>

<style lang="scss" scoped>
  .block:not(:last-child) {
    margin-bottom: 2em;
  }
  .title {
    font-family: "Robotoo";
    font-weight: normal;
  }
  p {
    font-family: "Robotoo";
    font-weight: $font-weight-light;
  }
  span {
    font-family: "Robotoo";
    font-weight: $font-weight-medium;
  }
  .arthur-image {
    max-width: 180px;
    position: absolute;
    bottom: 0;
    left: -170px;
    @media (max-width: 768px) {
      left: 23%;
      bottom: -485px;
      max-width: 300px;
      opacity: 0.3;
    }
    @media (max-width: 576px) {
      left: 5%
    }
  }
  .last {
    @media (min-width: 768px) {
      margin-bottom: 0;
    }
    margin-bottom: 80px;
  }
  .presentation-menu {
    @media (max-width: 768px) {
      position: unset;
    }
    position: fixed;
  }
</style>
